import React, { useState, useEffect, useContext } from "react";
import { Flex } from '@aws-amplify/ui-react';
import { Modal, Button, IconButton } from '@mui/material';
import { SigmaEmbed } from '../../../layouts/SigmaEmbed';
import Dev from '../../dev/Dev';
import { FiltersContext } from '../../../components/Navigation/Routes';
import featureToggle from '../../../featureToggle.json';
import ClearIcon from '@mui/icons-material/Clear';
import { useIdleTimer } from '../../../utils/IdleTimer';
import { Box } from '@mui/system';
import usersService from '../../../axios/usersService';
import styles from '../reportPageHeader.module.css';

export const Credit = ({ page }) => {
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const context = useContext(FiltersContext);
  const { channel, viewType, impersonatorInfo, setCreditTab } = context;

  const [openFAQ, setOpenFAQ] = useState(false);
  const handleOpenFAQ = () => setOpenFAQ(true);
  const handleCloseFAQ = () => setOpenFAQ(false);
  const [faqSource, setFAQSource] = useState(null);

  const handleOpenVendorPortal = () => {
    window.open('https://suppliers.usfood.com/', '_blank');
  };

  useIdleTimer(channel);

  useEffect(() => {
    const fetchFAQEmbed = async () => {
      const roleInformation =
        Object.values(impersonatorInfo).length === 0 ? {} : impersonatorInfo;
      roleInformation.view = viewType;
      const srcFAQ = await usersService.getEmbeddingUrl(
        'credit-faq',
        [],
        roleInformation,
        Object.values(impersonatorInfo).length > 0,
      );
      setFAQSource(srcFAQ);
    };

    if (page === 'credit') {
      fetchFAQEmbed();
    }
  }, [openFAQ, impersonatorInfo, viewType, page]);

  useEffect(() => {
    setCreditTab(0);

    return () => setCreditTab(0);
  }, [page, setCreditTab]);

  if (featureToggle[environment][page]) {
    return (
      <Flex
        direction={'column'}
        width={'100%'}
        height={'100%'}
        overflow={'hidden'}
        paddingTop={'12px'}
      >
        <Flex direction={'row'} className={styles['actions-row']}>
          <Button
            onClick={() => setCreditTab(0)}
            className="information-buttons"
          >
            CREDIT SUMMARY
          </Button>
          <Button
            onClick={() => setCreditTab(1)}
            className="information-buttons"
          >
            STANDARD PROGRAM SUMMARY
          </Button>
          <Button
            onClick={() => setCreditTab(2)}
            className="information-buttons"
          >
            DETAILED REPORTS
          </Button>
          <Flex direction={'row'} justifyContent={'flex-end'} width={'80%'}>
            <Button onClick={handleOpenVendorPortal} id="vendor-portal-button">
              US Foods Vendor Portal
            </Button>
            <Button onClick={handleOpenFAQ} id="vendor-metrics-button">
              Standard Supplier Program FAQs
            </Button>
            <Modal
              className="embed-popup"
              open={openFAQ}
              onClose={handleCloseFAQ}
            >
              <Box className="embed-popup-box">
                <div className="popup-close">
                  <IconButton onClick={handleCloseFAQ}>
                    <ClearIcon color={'error'} />
                  </IconButton>
                </div>
                <iframe
                  id={'FAQ'}
                  src={faqSource}
                  title={'FAQ'}
                  className="popup-iframe"
                />
              </Box>
            </Modal>
          </Flex>
        </Flex>
        <SigmaEmbed page={page} />
      </Flex>
    )
  } else {
    return <Dev />;
  }
};
